import React from "react";
import { Box, Button, Modal, Typography } from "@mui/material";
import { modalStyle } from "../../components/modalStyle";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import { useNavigate } from "react-router-dom";

export default function InactiveUserResponseModal({ openModal, setOpenModal }) {
  const handleClose = () => setOpenModal(false);
  const navigate = useNavigate();
  return (
    <Modal open={openModal} onClose={handleClose}>
      <Box sx={{ ...modalStyle, width: 600 }}>
        <Box sx={{ textAlign: "center" }}>
          <ReportProblemOutlinedIcon
            sx={{ color: "yellow", fontSize: 140, mb: 2 }}
          />
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Something went wrong!
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 1 }}>
            Please contact the administrator.
          </Typography>

          <Button
            variant="outlined"
            // color="success"
            onClick={() => {
              navigate("/");
              handleClose();
            }}
            sx={{ my: 3 }}
          >
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
